import { Injectable } from '@angular/core';

import { Repairer } from 'app/_models/repairers';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from './global-http.service';

@Injectable()
export class RepairerService {
  constructor(private http: HttpClient) { }

  getRepairers(customerId: number): Observable<Repairer[]> {
    return this.http.get<Repairer[]>('/api/customer_repairers/' + customerId + '/',);
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/repairers.service.ts